import { GetCacheByKeyType, ReqCacheType } from 'Helpers/cache/types'

class CustomCache {
	protected cachedRequest: ReqCacheType
	private timer: NodeJS.Timeout
	private TIMEOUT_MS = 5000
	constructor() {
		this.cachedRequest = new Map() as ReqCacheType
	}

	getCacheByKey(key: string | string[]): GetCacheByKeyType {
		if (key instanceof Array) {
			const cacheObj = key.reduce((accum, elem) => {
				if (this.cachedRequest.get(elem)) {
					return { ...accum, [elem]: this.cachedRequest.get(elem) }
				}
				return { ...accum }
			}, {})
			if (Object.keys(cacheObj).length) {
				return cacheObj
			}
			return undefined
		}
		return this.cachedRequest.get(key)
	}

	setCache(key: string, request: string): void {
		this.cachedRequest.set(key, request)
		if (this.timer) {
			clearTimeout(this.timer)
		}
		this.timer = setTimeout(this.clearCache.bind(this), this.TIMEOUT_MS)
	}

	clearCache(): void {
		this.cachedRequest.clear()
	}

	deleteCacheByKey(key: string | string[]): void {
		if (key instanceof Array) {
			key.forEach((elem) => this.cachedRequest.delete(elem))
		} else {
			this.cachedRequest.delete(key)
		}
	}

	hasCacheByValue(value: string): boolean {
		let hasCache = false
		// eslint-disable-next-line no-restricted-syntax
		for (const cacheValue of this.cachedRequest.values()) {
			if (cacheValue === value) {
				hasCache = true
			}
		}

		return hasCache
	}

	keyByValue(value: string): string | undefined {
		let key: string | undefined
		// eslint-disable-next-line no-restricted-syntax
		for (const [cacheKey, cacheValue] of this.cachedRequest.entries()) {
			if (cacheValue === value) {
				key = cacheKey
			}
		}
		return key
	}

	hasCache(key: string, value: string): boolean {
		return this.getCacheByKey(key) === value
	}
}

export const WorkerCache = new CustomCache()
